import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const POST_PROVIDER_RESET = 'POST_PROVIDER_RESET';
export const POST_PROVIDER_LOADING = 'POST_PROVIDER_LOADING';
export const POST_PROVIDER_SUCCESS = 'POST_PROVIDER_SUCCESS';
export const POST_PROVIDER_REJECT = 'POST_PROVIDER_REJECT';

//* ACTIONS ------------------------------------------------
export const postProviderReset = () => ({ type: POST_PROVIDER_RESET });
export const postProviderLoading = () => ({ type: POST_PROVIDER_LOADING });
export const postProviderSuccess = (payload) => ({ type: POST_PROVIDER_SUCCESS, payload });
export const postProviderReject = (payload) => ({ type: POST_PROVIDER_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const postProviderRequest = async (data, getState) => {
    const options = await withToken({
        method: Methods.POST,
        data,
    }, getState);
    return request(`/Providers/web/AddProviders`, options);
};


